import { Strategy } from 'types/realEstate.enum';

export const STRATEGY_DATA = [
  { id: Strategy.Patrimonial, name: 'realization.strategy.patrimonial' },
  {
    id: Strategy.Yield,
    name: 'realization.strategy.yield',
  },
];
